module.exports = __webpack_public_path__ + "img/hero_image2.2c5b21f5.png";